const config = {
  zonas: [
     { codigo: '2021', nombre: 'FS Planta' },
     { codigo: '67', nombre: 'Facebook' },
      { codigo: '79', nombre: 'FIAT (SUR)' },
     { codigo: '80', nombre: 'FIAT CENTRAL' },
     { codigo: '48', nombre: 'CNH (CORDOBA)' },
     { codigo: '108', nombre: 'IVECO-CORDOBA' },
     { codigo: '506-511', nombre: 'Mercado Libre', codigos: ['506', '507', '508', '509', '510', '511'] },
     { codigo: '2022', nombre: 'Larrazabal 2' },
      { codigo: '298', nombre: 'Metalsa' },
      { codigo: '484', nombre: 'MALTERIA QUILMES' },
       { codigo: '130', nombre: 'LEAR PACHECO' },

    
   ],
   operaciones: {
     'empresa-000558': 'MARKETING/PLANTA',
     'empresa-000553': 'FACTURACIÓN/PLANTA',
     'empresa-000559': 'COSTOS/PLANTA',
     'empresa-001016': 'NUTRICIÓN/PLANTA',
     'empresa-000555': 'RRHH/PLANTA',
     'empresa-000562': 'DIRECCIÓN/PLANTA',
     'empresa-000659': 'GERENTE/ZONAL',
     'empresa-000066': 'JEFE COCINA/PLANTA',
     'empresa-000564': 'SELECCIÓN/PLANTA',
     'empresa-000170': 'LOGISTICA/PLANTA',
     'empresa-000544': 'CALIDAD/PLANTA',
     'empresa-000563': 'LEGALES/PLANTA',
     'empresa-000554': 'COORDINACIÓN/PL,TA',
     'empresa-000556': 'COMPRAS/PLANTA',
     'empresa-000561': 'PRE-ELABORADOS/PLANTA',
     'empresa-000168': 'ARMADO/PLANTA',
     'empresa-000552': 'TESORERÍA/PLANTA',
     'empresa-999999': 'ASIGNACIÓN TEMPORAL',
     'empresa-999991': 'SECTOR ZONALES',
     'empresa-900101': 'VOLANTES',
     'empresa-900102': 'PRE-LEGALES',
     'empresa-999992': 'COCINA GOURMET/PLANTA',
     'empresa-999993': 'EATY/PLANTA',
     'empresa-999994': 'PAGO A PROVEEDORES/PLANTA',
     'empresa-999995': 'COCINA/PLANTA',
     'empresa-999996': 'CONTADURÍA/PLANTA',
     'empresa-999997': 'CALIDAD/OPERACIONES',
     'empresa-999998': 'MANTENIMIENTO/PLANTA',
     'empresa-100111': 'CAPACITACIÓN/OPERACIONES',
     'empresa-100112': 'SISTEMAS/PLANTA',
     'empresa-010017': 'CONTABILIDAD'
   },
}

export default config